export default __webpack_public_path__ + "static/media/edit.ca058bb4.svg";